import { useState, useEffect, useRef } from 'react'

/** Duration of the one-shot "you just picked your Banker" heartbeat-bounce
 * pop. */
export const LEADER_LANDING_ANIMATION_MS = 550

/** One-shot "you just picked your Banker" pop: fires only on
 * the `false -> true` transition of `isBanker` within the same mount — the
 * moment worth celebrating is the tap itself — and deliberately stays silent
 * if `isBanker` is already true at mount (e.g. navigating back to an
 * already-picked fixture). */
export function useBankerPickedLanding(isBanker: boolean, delayMs = 0): boolean {
  const [isLanding, setIsLanding] = useState(false)
  const wasBankerRef = useRef(isBanker)

  useEffect(() => {
    const justPicked = isBanker && !wasBankerRef.current
    wasBankerRef.current = isBanker
    if (!justPicked) return
    if (
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return
    }
    const startTimer = setTimeout(() => setIsLanding(true), delayMs)
    return () => clearTimeout(startTimer)
  }, [isBanker, delayMs])

  useEffect(() => {
    if (!isLanding) return
    const endTimer = setTimeout(() => setIsLanding(false), LEADER_LANDING_ANIMATION_MS)
    return () => clearTimeout(endTimer)
  }, [isLanding])

  return isLanding
}
